import { MappingDisplayItemWithForm } from './MappingDisplayItemWithForm.type';
import { MappingDisplayItemWithNoForm } from './MappingDisplayItemWithNoForm.type';

export type MappingDisplayItem = MappingDisplayItemWithNoForm | MappingDisplayItemWithForm;
